import {
    customersExpansionPotentialFilter,
    customersRevenueDeclineFilter,
    type CustomerListParams,
} from '@plato/app-shared/utils/customer-list';
import type { QuickFilter } from '@plato/ui-legacy/components/filters/lib/filter-utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useCustomerListQuickFilters(): QuickFilter<CustomerListParams>[] {
    const { t } = useTranslation('customer-list');

    return useMemo(
        () => [
            {
                id: 'my-expansion-potential',
                label: t('quick_filters__customers_my_plus_customers'),
                showByDefault: true,
                filter: customersExpansionPotentialFilter,
            },
            {
                id: 'my-revenue-decline',
                label: t('quick_filters__customers_my_minus_customers'),
                showByDefault: true,
                filter: customersRevenueDeclineFilter,
            },
        ],
        [t],
    );
}
